// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3ldW5","box":"WorkspacesBox_box__1Gvju","node":"WorkspacesBox_node__1RbkR"};